// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const WorkflowBuilderPage = lazy(() => import('./pages/WorkflowBuilderPage'));
const ProcessAutomationPage = lazy(() => import('./pages/ProcessAutomationPage'));
const WebhookOutboundPage = lazy(() => import('./pages/WebhookOutboundPage'));
const WebhookInboundPage = lazy(() => import('./pages/WebhookInboundPage'));
const SmartActionsPage = lazy(() => import('./pages/SmartActionsPage'));
const DataTransformationPage = lazy(() => import('./pages/DataTransformationPage'));

export const AutomationRoutes: RouteObject = {
  path: 'automation',
  element: <ModuleGuard moduleId="core.automation" />,
  children: [
    { path: 'workflow-builder', element: <WorkflowBuilderPage />, handle: { crumb: 'Workflow Builder' } },
    { path: 'process-automation', element: <ProcessAutomationPage />, handle: { crumb: 'Process Automation' } },
    { path: 'webhook-outbound', element: <WebhookOutboundPage />, handle: { crumb: 'Webhook Outbound' } },
    { path: 'webhook-inbound', element: <WebhookInboundPage />, handle: { crumb: 'Webhook Inbound' } },
    { path: 'smart-actions', element: <SmartActionsPage />, handle: { crumb: 'Smart Actions' } },
    { path: 'data-transformation', element: <DataTransformationPage />, handle: { crumb: 'Data Transformation' } },
  ],
};
